import React, { useState } from "react";
import axios from "axios";
import Frame from "../components/Frame";
import { SOCIAL_LINKS } from "../components/Social";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setStatus({
        state: "error",
        msg: "Please fill in your name, email and message.",
      });
      return;
    }
    setStatus({ state: "loading", msg: "" });
    try {
      await axios.post(`${API}/contact`, form);
      setStatus({
        state: "success",
        msg: "Thank you — your message is on its way. We'll be in touch within 48 hours.",
      });
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      setStatus({
        state: "error",
        msg: "Something went wrong sending your message. Please email sunstatecollective@gmail.com directly.",
      });
    }
  };

  return (
    <div className="sc-page sc-page-contact" data-testid="page-contact">
      <Frame as="section" className="sc-page-hero" testId="contact-hero">
        <span className="sc-section-eyebrow">GET IN TOUCH</span>
        <h1 className="sc-page-title">Let&rsquo;s talk</h1>
        <p className="sc-page-sub">
          For new event enquiries, please use the relevant{" "}
          <a href="/events">enquiry form</a> so we can quote accurately. For
          general questions, send a note below or email us directly.
        </p>
      </Frame>

      <Frame as="section" className="sc-contact" testId="contact-grid">
        <div className="sc-contact-info">
          <h2>Reach us</h2>
          <ul>
            <li>
              <span className="sc-contact-label">Email</span>
              <a href="mailto:sunstatecollective@gmail.com">
                sunstatecollective@gmail.com
              </a>
            </li>
            <li>
              <span className="sc-contact-label">Service area</span>
              <span>Gold Coast &amp; Brisbane, QLD</span>
            </li>
            <li>
              <span className="sc-contact-label">Response time</span>
              <span>Within 48 hours, Mon&ndash;Sun</span>
            </li>
            <li>
              <span className="sc-contact-label">Social</span>
              <span className="sc-contact-social">
                <a
                  href={SOCIAL_LINKS.instagram}
                  onClick={(e) => {
                    e.preventDefault();
                    const w = window.open(SOCIAL_LINKS.instagram, "_blank");
                    if (!w) window.location.href = SOCIAL_LINKS.instagram;
                  }}
                  data-testid="contact-social-instagram"
                >
                  Instagram
                </a>
                <span aria-hidden="true"> · </span>
                <a
                  href={SOCIAL_LINKS.tiktok}
                  onClick={(e) => {
                    e.preventDefault();
                    const w = window.open(SOCIAL_LINKS.tiktok, "_blank");
                    if (!w) window.location.href = SOCIAL_LINKS.tiktok;
                  }}
                  data-testid="contact-social-tiktok"
                >
                  TikTok
                </a>
                <span aria-hidden="true"> · </span>
                <a
                  href={SOCIAL_LINKS.facebook}
                  onClick={(e) => {
                    e.preventDefault();
                    const w = window.open(SOCIAL_LINKS.facebook, "_blank");
                    if (!w) window.location.href = SOCIAL_LINKS.facebook;
                  }}
                  data-testid="contact-social-facebook"
                >
                  Facebook
                </a>
                <br />
                <span className="sc-contact-handle">@sunstatecollective</span>
              </span>
            </li>
          </ul>
        </div>

        <form
          className="sc-contact-form"
          onSubmit={submit}
          data-testid="contact-form"
        >
          <div className="sc-form-field">
            <label htmlFor="cf-name">Name</label>
            <input
              id="cf-name"
              type="text"
              value={form.name}
              onChange={update("name")}
              data-testid="contact-input-name"
              required
            />
          </div>
          <div className="sc-form-row">
            <div className="sc-form-field">
              <label htmlFor="cf-email">Email</label>
              <input
                id="cf-email"
                type="email"
                value={form.email}
                onChange={update("email")}
                data-testid="contact-input-email"
                required
              />
            </div>
            <div className="sc-form-field">
              <label htmlFor="cf-phone">Phone (optional)</label>
              <input
                id="cf-phone"
                type="tel"
                value={form.phone}
                onChange={update("phone")}
                data-testid="contact-input-phone"
              />
            </div>
          </div>
          <div className="sc-form-field">
            <label htmlFor="cf-subject">Subject</label>
            <input
              id="cf-subject"
              type="text"
              value={form.subject}
              onChange={update("subject")}
              data-testid="contact-input-subject"
              placeholder="e.g. Question about hotel setups"
            />
          </div>
          <div className="sc-form-field">
            <label htmlFor="cf-message">Message</label>
            <textarea
              id="cf-message"
              rows={6}
              value={form.message}
              onChange={update("message")}
              data-testid="contact-input-message"
              required
            />
          </div>

          {status.msg && (
            <div
              className={`sc-form-status sc-form-status-${status.state}`}
              data-testid="contact-status"
            >
              {status.msg}
            </div>
          )}

          <button
            type="submit"
            className="sc-btn-primary sc-btn-full"
            disabled={status.state === "loading"}
            data-testid="contact-submit"
          >
            {status.state === "loading" ? "SENDING…" : "SEND MESSAGE"}
          </button>
        </form>
      </Frame>
    </div>
  );
};

export default Contact;
